import { Reveal } from "./Reveal";

const STEPS = [
  ["01", "Choose your time", "Select an available date and appointment time on the website."],
  ["02", "Tell us about your goals", "Complete a short registration form."],
  ["03", "Get clarity", "Attend your briefing and discuss your questions."],
];

export function HowItWorks() {
  return (
    <section id="how" className="relative py-24 sm:py-32 px-6 sm:px-10 bg-[#071426] text-white overflow-hidden grain" data-testid="how-section">
      <div className="pointer-events-none absolute -top-40 left-1/2 h-[480px] w-[480px] -translate-x-1/2 rounded-full bg-[#C7A76C]/10 blur-3xl" />
      <div className="relative max-w-6xl mx-auto">
        <Reveal>
          <p className="eyebrow">How it works</p>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold">Three calm steps.</h2>
        </Reveal>
        <div className="mt-16 grid md:grid-cols-3 gap-12 md:gap-0">
          {STEPS.map(([n, title, text], i) => (
            <Reveal key={n} delay={i * 0.12}>
              <div className={`md:px-10 ${i === 0 ? "md:pl-0" : "md:border-l border-white/10"}`} data-testid={`how-step-${n}`}>
                <span className="font-display text-6xl sm:text-7xl font-bold text-transparent [-webkit-text-stroke:1px_rgba(199,167,108,0.7)]">{n}</span>
                <h3 className="font-display mt-6 text-xl font-semibold">{title}</h3>
                <p className="mt-3 text-white/60 leading-relaxed">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
